<template>

 <div>
    <div class="designer_head ellipsis">
       <span class="head_title">{{ HeadTitle }}</span>
       <div class="head_count">{{ ordersCount }}</div>
       <div class="button_region">
            <div class="add_order toggle_button" @click="toggleOrders">
                <img src="./assets/down_arrow.png" v-if="ordersVisible">
                <img src="./assets/right_arrow.png" v-if="!ordersVisible">
            </div>
       </div>
    </div>
    <q-slide-transition>
        <div class="ordersContainer q-pa-xs" v-if="ordersVisible" v-bind:class="{'q-pa-sm' : $q.screen.gt.sm}">
                <main-order-line v-for="(order) in check_orders" 
                    :key="order.id" 
                    :order="order" 
                    :index='order.id'/>
        </div>
    </q-slide-transition>

 </div>

</template>

<script>
/* eslint-disable */
import MainOrderLine from './MainOrderLine'


export default {
    name : 'InWorkOrders',

    components : {
        MainOrderLine,
    },

    data () {
        return {
            HeadTitle: 'Находится в работе',
            ordersVisible : true,
        }
    },
    
    computed: {

      check_orders() {
           return this.$store.getters.inWorkOrders.sort(function(a,b) {
               if (a.id > b.id) return -1;
               if (a.id < b.id) return 1;
               if (a.id == b.id) return 0;
           });
      },
      
       ordersCount() {
          return this.$store.getters.inWorkOrders.length;
      }
    

    },
    
    methods : {
        toggleOrders() {
            this.ordersVisible = !this.ordersVisible;
        },
    }

}
</script>

<style lang="scss" scoped>

@import url("https://cdn.jsdelivr.net/npm/animate.css@3.5.2/animate.min.css");

.designer_head {
        display: flex;
        align-items: center;
        animation-duration: 0.3s;
        height : 45px;
        background: rgb(52, 158, 3);
        padding-left : 15px;

    .head_title {
        font-size:18px;
        color : white;
        padding-top : 15px;
        text-transform: uppercase; 
        white-space:  nowrap;
    }
    .head_count {
        margin-left:20px;
        color : white;
        background : rgb(1, 139, 13);
        min-width : 60px;
        height : 45px;
        font-size: 28px;
        font-weight: bold;
        padding-left: 10px;
        padding-right: 10px;
        padding-top : 8px;
        text-align: center;
    }
    .add_order {
        width : 80px;
        height : 45px;
        text-align: center;
        font-size: 40px;
        cursor: pointer;
        &:hover {
            background : rgb(1, 139, 13);
            color : rgb(4, 134, 4);
        }
    }
    .button_region {
        width : 100%;
        display : flex;
        justify-content : flex-end;
        
    }
}
.ordersContainer{
    border : 1px solid rgb(182, 182, 182);
    border-top : 0px;
    width : 100%;
    // height : 300px;
    animation-duration: 1s;
}





</style>

